import { Component, OnInit } from '@angular/core';

import { GroupService } from '../../services/group.service';
import { NaviService } from '../../services/navi.service';
import { Study } from '../../models/study';
import { BasicError, Error403 } from '../../models/error/error';

@Component({
  selector: 'app-my-groups',
  templateUrl: './my-groups.component.html',
  styleUrls: ['./my-groups.component.css']
})
export class MyGroupsComponent implements OnInit {

  public myObj = [];
  public isEmpty = false;
  public studyId: String;
  public studyTitle: String;
  public isUnsubscribed = false;
  public amountStudies;

  /**
   * Vars for navigate
   */
  public groupdetailspatientUrl: String;

  constructor(private myGroups: GroupService, private naviService: NaviService) {
    this.getGroups();

    if (this.myObj.length === 0) {
      this.isEmpty = true;
    }

  }

  ngOnInit() {
  }

  public unsubscribeFromGroup(stId: String, stTitle: String) {
    this.isUnsubscribed = false;

    this.studyId = stId;
    this.studyTitle = stTitle;
  }

  public finallyUnsubscribeFromGroup() {
    this.myGroups.unsubscribeFromGroup(this.studyId).subscribe(data => {
      if (data instanceof BasicError) {
        console.log(data);
      }
    });

    this.getGroups();
    this.isUnsubscribed = true;
  }

  public getGroups() {
    this.myGroups.getMyGroups().subscribe(data => {
      this.myObj = [];
      for (const group of data) {
        if (group instanceof Study && group.getId() === '1') {
          continue;
        }
        this.myObj.push(group);
      }

      // this.myObj = data;
      this.amountStudies = this.myObj.length;

      if (this.myObj.length === 0) {
        this.isEmpty = true;
      } else {
        this.isEmpty = false;
      }
    });
  }

  public navigateToGroupDetailsPatient(stId: String) {
    this.groupdetailspatientUrl = 'mygroups/' + stId;

    this.naviService.navigateToUrl(this.groupdetailspatientUrl, 'myGroups');
  }

  public navigateToGroupStatistics() {
    const statUrl = 'mygroups/1/statistics';

    this.naviService.navigateToUrl(statUrl, 'myGroups');
  }

  /**
   * Navigate to follow string
   * @param name string to navigate to
   */
  public navigate(name: String): void {
    this.naviService.setCurrentPage(name);
  }

}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/my-groups/my-groups.component.ts